import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export type RefineOptions = {
  currentSelectedcontentStyle?: string;
  currentSelectedExclusion?: string;
  currentSelectedInclusion?: string;
  currentSelectedToneLevel?: string;
  currentSelectedContentStyle?: string;
};

export const refineOptionsStateSegment = stateSegmentWithReset<RefineOptions>({
  currentSelectedcontentStyle: '',
  currentSelectedExclusion: '',
  currentSelectedInclusion: '',
  currentSelectedToneLevel: '',
  currentSelectedContentStyle: '',
});

refineOptionsStateSegment.debugLabel = 'refineOptionsStateSegment';
